import React from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch
} from 'react-router-dom';

import CookieMessage from '../CookieMessage';
import Notification from '../Notification';
import ScrollToTop from '../ScrollToTop';
import Header from '../Header';
import Day from '../Day/index.js';
import NotFoundPage from '../404';
import HelpPage from '../Help';
import Maintenance from '../Maintenance';
import ErrorPage from '../Error';

import * as ROUTES from '../../constants/routes';

const App = () => {
	const maintenance = false;

	// bfcache fix
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	}

	if (maintenance) {
		return (
			<>
				<Header />
				<main><Maintenance /></main>
				<Modals />
			</>
		);
	} else {
		return (
			<Router>
				<ScrollToTop />
				<Header />

				<main>
					<Switch>
						<Route exact path={ROUTES.HELP} component={() => (<HelpPage />)} />
						<Route exact path={ROUTES.HOME} component={() => (<Day />)} />
						<Route exact path={ROUTES.NOT_FOUND} component={NotFoundPage} />
						<Route exact path={ROUTES.ERROR} component={ErrorPage} />
						<Route component={NotFoundPage} />
					</Switch>
				</main>

				<Modals />
			</Router>
		);
	}
};

const Modals = () => (
	<div className="modals">
		<Notification />
		<CookieMessage />
	</div>
);

export default App;